/**
 * Rich Text Editor inline sample
 */
import React, { useMemo, useRef } from "react";

import { DefaultHtmlAttributes } from "@syncfusion/ej2-react-base";
import {
  FontFamilyModel,
  FormatModel,
  HtmlEditor,
  Image,
  Inject,
  Link,
  PasteCleanup,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar,
  ToolbarSettingsModel
} from "@syncfusion/ej2-react-richtexteditor";
import type { RichTextEditorModel } from "@syncfusion/ej2-richtexteditor/src/rich-text-editor/base/rich-text-editor-model";
import cs from "classnames";

interface Props extends RichTextEditorModel, DefaultHtmlAttributes {
  id: string;
  rteRef?: React.MutableRefObject<RichTextEditorComponent | null>;
  isRtl?: boolean;
  onRtlSwitch?: (value: boolean) => unknown;
  placeholderOnFocus?: boolean;
  placeholderOnHover?: boolean;
}

export const RichTextEditor: React.FC<Props> = ({
  rteRef,
  cssClass = "",
  isRtl = false,
  onRtlSwitch,
  change,

  toolbarSettings,
  placeholderOnFocus = false,
  placeholderOnHover = false,
  ...rteProps
}) => {
  const innerRef = useRef<RichTextEditorComponent>(null);
  const ref = rteRef || innerRef;
  const format: FormatModel = {
    width: "auto"
  };
  const fontFamily: FontFamilyModel = {
    width: "auto"
  };

  //Rich Text Editor ToolbarSettings
  const toolbarSettingsFinal: ToolbarSettingsModel = useMemo(() => {
    const settings: ToolbarSettingsModel = {
      ...toolbarSettings,
      items: ["Bold", "Italic", "Underline", "Formats", "-", "Alignments", "OrderedList", "UnorderedList", "CreateLink"]
    };

    if (onRtlSwitch) {
      settings.items?.push({
        template:
          // eslint-disable-next-line quotes
          '<button class="e-tbar-btn e-control e-btn e-lib e-icon-btn"><span class="e-btn-icon e-icons rte-custom-ltr"></span></button>',
        tooltipText: "LTR Mode",
        click: () => onRtlSwitch?.(false)
      });
      settings.items?.push({
        template:
          // eslint-disable-next-line quotes
          '<button class="e-tbar-btn e-control e-btn e-lib e-icon-btn"><span class="e-btn-icon e-icons rte-custom-rtl"></span></button>',
        tooltipText: "RTL Mode",
        click: () => onRtlSwitch?.(true)
      });
    }
    return settings;
  }, [onRtlSwitch]);

  return (
    <RichTextEditorComponent
      cssClass={cs("rich-text-editor", cssClass, {
        "placeholder-only-on-focus": placeholderOnFocus,
        "placeholder-on-hover": placeholderOnHover
      })}
      ref={ref}
      toolbarSettings={toolbarSettingsFinal}
      format={format}
      enableRtl={isRtl}
      fontFamily={fontFamily}
      {...rteProps}
      // created={() => setDirAttribute(ref)}
      change={(...args) => {
        change?.(...args);
        // setDirAttribute(ref);
      }}
    >
      <Inject services={[Image, Link, QuickToolbar, HtmlEditor, Toolbar, PasteCleanup]} />
    </RichTextEditorComponent>
  );
};

// function setDirAttribute(ref: React.RefObject<RichTextEditorComponent>) {
//   if (ref.current) {
//     const contentArea = ref.current.getContent().getElementsByClassName("e-content")[0];
//     if (contentArea) {
//       contentArea.setAttribute("dir", "auto");
//     }
//   }
// }
